// A conversation's member or coach may have been removed; show a clear name instead of crashing
// (same names as the API's placeholder sender, thewebops/nutivate-api#91).
export const REMOVED_NAMES = { user: "Removed member", coach: "Removed coach" };

export const findParticipant = (participations, type) =>
  participations?.find((participation) => participation?.participant_type === type)?.participant;

// Only a missing participant counts as removed, not one who has no name.
export const participantName = (participations, type) => {
  const participant = findParticipant(participations, type);
  if (!participant) return REMOVED_NAMES[type];
  return participant.name ?? "";
};
